import backend from '@api/backend'
import { ActionTypes } from './30days.reducer'
import { displayToast } from '@common/utils/appToast'
import { DeviceIDTypes } from '@context/device/model/device'

export type ReportQuery = {
  deviceId: string
  offPeakBaseline?: number
  offPeakStartHour?: number
  offPeakEndHour?: number
  projectedSaving : number
  uom: string
  idType: DeviceIDTypes
}

export const get30DaysReportAction = async (reportQuery: ReportQuery, dispatch: any) => {
  const { deviceId, ...params} = reportQuery
  try {
    dispatch({ type: ActionTypes.LOADING })
    const report30days = await backend.get(
      `/reports/${deviceId}/initial_30_day_report`, { params: params }
    )

    const data = report30days.data
    dispatch({ type: ActionTypes.LOADED_30_DAYS_REPORTS, payload: { query: reportQuery, data } })
  } catch (error: any) {
    displayToast({
      type: 'error',
      message: error?.response?.data?.detail || 'Something went wrong',
    })
    dispatch({ type: ActionTypes.ERROR })
  }
}
